import React from "react";
import { UseFormReturn } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

import { Button } from "../../../components/button";

import { CardHeader } from "../../../components/cards";

interface IProductForm {
  loading: boolean;
  submit: any;
  form: UseFormReturn<any, any>;
  disabledFields?: string[];
}

export const ProductForm: React.FC<IProductForm> = ({
  loading,
  submit,
  form,
  disabledFields = [],
}) => {
  return (
    <section className="section">
      <div className="element">
        <div className="card">
          <CardHeader title="Informations Générales" />
          <div className="w-full">
            <div className="w-full mb-2">
              <p className="label">Nom du produit</p>
              <input
                className="w-full input"
                type="text"
                {...form.register("name", {
                  required: "Le nom du produit est requis",
                })}
                placeholder="Nom du produit"
              />

              <ErrorMessage
                errors={form.formState?.errors}
                name="name"
                render={({ message }) => (
                  <p className="error-message">{message}</p>
                )}
              />
            </div>

            <div className="w-full mb-2">
              <p className="label">Référence du produit</p>
              <input
                className="w-full input"
                type="text"
                {...form.register("reference", {
                  required: "La référence du produit est requis",
                })}
                placeholder="Référence du produit"
              />

              <ErrorMessage
                errors={form.formState?.errors}
                name="reference"
                render={({ message }) => (
                  <p className="error-message">{message}</p>
                )}
              />
            </div>

            <div className="w-full mb-2">
              <p className="label">URL</p>
              <input
                className="w-full input"
                type="text"
                {...form.register("url", {
                  required: "La url du client est requise",
                })}
                placeholder="url"
              />

              <ErrorMessage
                errors={form.formState?.errors}
                name="url"
                render={({ message }) => (
                  <p className="error-message">{message}</p>
                )}
              />
            </div>

            <div className="w-full mb-2">
              <p className="label">Image du produit</p>
              <input
                className="w-full input"
                type="text"
                {...form.register("imgUrl", {
                  required: "La description du client est requise",
                })}
                placeholder="Image du produit"
              />

              <ErrorMessage
                errors={form.formState?.errors}
                name="imgUrl"
                render={({ message }) => (
                  <p className="error-message">{message}</p>
                )}
              />
            </div>
            <div className="w-full mb-2">
              <p className="label">Dernière quantité du produit</p>
              <input
                className="w-full input"
                type="text"
                {...form.register("lastQuantity", {
                  required: "La description du client est requise",
                })}
                placeholder="Dernière quantité du produit"
              />

              <ErrorMessage
                errors={form.formState?.errors}
                name="imgUrl"
                render={({ message }) => (
                  <p className="error-message">{message}</p>
                )}
              />
            </div>
            <div className="w-full mb-2">
              <p className="label">Dernier prix du produit</p>
              <input
                className="w-full input"
                type="text"
                {...form.register("lastPrice", {
                  required: "La description du client est requise",
                })}
                placeholder="Dernière quantité du produit"
              />

              <ErrorMessage
                errors={form.formState?.errors}
                name="lastPrice"
                render={({ message }) => (
                  <p className="error-message">{message}</p>
                )}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="left mt-2">
        <Button
          disabled={!form.formState.isValid}
          loading={loading}
          onClick={submit}
        >
          Valider
        </Button>
      </div>
    </section>
  );
};
